module.exports = __webpack_public_path__ + "media/luxury-2026/timber-dining-960-d4f29cac.jpg";